import React from 'react';
import AuthPageTemplate from './template/auth-page';
import TrailsPanel from './../ui/panel/trails';
import ProfileMenu from './../ui/menu/profile';

const TrailsPage = () => {
    return (
        <AuthPageTemplate childMenu={
            <div>
                <ProfileMenu />
            </div>
        }>
            <TrailsPanel />
        </AuthPageTemplate>
    );
};

export default TrailsPage;
